<template>
  <article class="group">
    <header @click.alt="newGroupLeader">
        <h2>{{group.name}}</h2>
    </header>
    <Draggable v-model="group.members" v-bind="{group: 'group'}" :move="handleMove" >
            <div class="member" 
            v-for="(member, index) of group.members"
            :key="index"
            @click="removeMember($event,index)"  
            :class="{ leader : index == group.leaderIndex }"
            >{{member}}</div>
    </Draggable>
  </article>
</template>

<script>
import Draggable from 'vuedraggable';

export default {
    name: 'Group',
    components: {
        Draggable
    },
    props: {
        group: Object
    },
    methods: {
        removeMember($event, index){
            if($event.altKey){
                this.group.members.splice(index, 1);
            }
        },
        newGroupLeader(){
            this.group.leaderIndex = Math.floor(Math.random()*this.group.members.length)
        },
        handleMove(e){
            if(e.from.children.length <= 1){
                console.log(this.group.id) // remove
                this.$el.parentNode.removeChild(this.$el);
            }
        }
    }
}

</script>

<style lang="scss" scoped>
@import './../scss/variables';

    .group {

        header {
            background: rgba($color: $black, $alpha: .8);
            display: flex;
            @include center;
            color: $white;
            height: $baseline * 3;
            border-top-left-radius: $radius;
            border-top-right-radius: $radius;

            &:hover {
                cursor: pointer;
            }
        }

        .member {
            background: $white;
            padding: .5rem 1rem;
            border-bottom: 1px solid rgba($color: $black, $alpha: .1);
            font-size: $font-sml;
            font-weight: 300;
            transition: all .2s ease;

            &.leader {
                font-weight: 500;

                &::before {
                    content: url('./../assets/crown.svg');
                }
            }

            &.sortable-chosen {
                transform: scale(1.05);
            }

            &.sortable-ghost {
                opacity: .9;
            }

            &:last-child {
                border: none;
                border-bottom-left-radius: $radius;
                border-bottom-right-radius: $radius;

            }
        }
    }

</style>

